<template>
  <div class="container" :class="{en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
    <section class="main-block">
      <section class="main-tit">
        <div class="tit-des">{{$t('about.des')}}</div>
        <span class="tit-slice"></span>
        <div class="tit-en-des" v-if="$area !== 'komoe-sea'">{{$t('about.enDse')}}</div>
      </section>
      <section class="main-con">
        <div class="con-tit" v-if="$area !== 'komoe-sea'">{{$t('about.hint')}}</div>
        <div class="con-block con-about" v-html="$t('about.article')">
        </div>
      </section>
    </section>
  </div>
</template>
<script>
export default {
  name: "about-h5"
}
</script>
<style lang="scss" scoped>
*:focus {
  outline: none;
  background-color: transparent;
}

a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
html {
  background-color: #eeeeee;
  overflow: auto;
}
main {
  position: relative;
}

.container {
  position: relative;
  margin: 0 auto;
  padding: 0.48rem 0.12rem;
  min-height: calc(100vh - 1.32rem);
  box-sizing: border-box;
  font-size: 0.16rem;
  background: #ffffff;
  word-break: break-all;
  &.en {
    .main-tit {
      border: none;
    }
    .tit-des {
        font-weight: bold;
    }
  }
}
.container.mgt_108 {
  padding-top: 1.28rem;
}
.container.mgt_48 {
  padding-top: 1.68rem;
}
.main-block {
  width: 100%;
  margin: 0 auto;
  font-size: 0.2rem;
}

.main-tit {
  padding-top: 8.9%;
  text-align: center;
  border-bottom: 1px solid #ccc;
}

.main-tit .tit-slice {
  width: 24px;
  height: 4px;
  background: #2da2d4;
  border-radius: 100px;
  vertical-align: middle;
  font-size: 0.16rem;
}

.main-tit .tit-en-des {
  padding-bottom: 3.5%;
  font-size: 0.1rem;
  color: #cccccc;
  letter-spacing: 0;
  line-height: 17px;
}

.main-tit .tit-des {
  font-size: 0.2rem;
  color: #444444;
  letter-spacing: 0;
}

.main-tit span {
  display: inline-block;
}

.main-con .con-tit {
  padding-top: 9.2%;
  font-size: 0.16rem;
  font-weight: bold;
  color: #2da2d4;
  line-height: 31px;
  text-align: center;
}

.main-con .con-block {
  padding-top: 5.9%;
  color: #444;
}

.main-con .con-about {
  font-size:0.14rem;
  line-height: 0.28rem;
}
</style>